/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = ServiceBooking
 *
 * 1 = WipAppointmentPreparation
 *
 * 2 = WorkshopCheckin
 *
 * 3 = WorkshopLog
 */
export enum MotRequestSource {
  ServiceBooking = 0,
  WipAppointmentPreparation = 1,
  WorkshopCheckin = 2,
  WorkshopLog = 3,
}
